import React from "react";
import { OrdersPolaris } from "../../components/order/OrdersPolaris";
import { ORDER_FILTER_SELLER } from "../../constants";
import { getPathFromRouter } from "../../helper";
import { USER_ROLE } from "../../variable";

export const AdminOrdersPagePolaris = (...props) => {
    const path = React.useMemo(() => {
        return getPathFromRouter(props);
    }, [props]);

    return (
        <OrdersPolaris
            role={USER_ROLE.Admin}
            ordersFilter={ORDER_FILTER_SELLER}
            path={path}
        />
    );
};
